import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import clsx from "clsx";

type ToastItem = { id: number; text: string; variant: "success" | "error" | "info" };

let _id = 1;

export function toast(text: string, variant: ToastItem["variant"] = "info") {
  window.dispatchEvent(new CustomEvent("app:toast", { detail: { id: _id++, text, variant } }));
}

export function Toaster() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    const onToast = (e: Event) => {
      const detail = (e as CustomEvent).detail as ToastItem;
      setItems((prev) => [...prev, detail]);
      // авто-закрытие
      setTimeout(() => {
        setItems((prev) => prev.filter((t) => t.id !== detail.id));
      }, 2500);
    };
    window.addEventListener("app:toast", onToast as EventListener);
    return () => window.removeEventListener("app:toast", onToast as EventListener);
  }, []);

  return (
    <div className="pointer-events-none fixed top-3 right-3 z-[100] flex flex-col gap-2">
      <AnimatePresence initial={false}>
        {items.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: -10, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.97 }}
            className={clsx(
              "pointer-events-auto rounded-xl px-3 py-2 text-sm shadow-lg backdrop-blur-md border",
              t.variant === "success" && "bg-emerald-500/15 border-emerald-400/25 text-emerald-200",
              t.variant === "error" && "bg-rose-500/15 border-rose-400/25 text-rose-200",
              t.variant === "info" && "bg-white/10 border-white/15 text-white/85"
            )}
          >
            {t.text}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
